import { Outlet, Navigate } from "react-router-dom";
import { useAuth } from "@xinosolutions/xs-auth-react";
import AppLoader from "../components/GeneralComponents/AppLoader";
import SiteHeader from "../components/portal/SiteHeader";

export default function LogoOnlyLayout() {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <AppLoader wrapperClassName="circular-progress circular-progress--viewport" />;
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="portal-shell">
      <SiteHeader />
      <main className="portal-main">
        <Outlet />
      </main>
    </div>
  );
}
